import React from 'react'
import SharedOverrideHeaderChips from '../../../components/OverrideHeaderChips'
import { PlanBenefitOverrideRuleStatus } from '../enums/plan-benefit-override-rule.enum'

interface Props {
  status: PlanBenefitOverrideRuleStatus
}

export default function OverrideHeaderChips({ status }: Props) {
  return <SharedOverrideHeaderChips label="Plan Benefits" status={status} />
}
